import { useSelector } from 'react-redux';
import { selectAllInventory } from '../../redux/inventorySlice';
import { InventoryItem } from '../../redux/inventorySlice';

export interface RecentFood {
  name: string;
  category: string;
}

/**
 * Extract unique recent foods from inventory items, sorted by recency.
 * @param items - All inventory items (any status)
 * @param limit - Max number of recent foods to return (default 8)
 * @returns Unique foods sorted by newest dateAdded first
 */
export function recentFoods(items: InventoryItem[], limit = 8): RecentFood[] {
  const seen = new Set<string>();
  const result: RecentFood[] = [];

  // Sort by dateAdded descending (newest first)
  const sorted = [...items].sort((a, b) => {
    const dateA = new Date(a.dateAdded).getTime();
    const dateB = new Date(b.dateAdded).getTime();
    return dateB - dateA;
  });

  for (const item of sorted) {
    // Normalize name for uniqueness check
    const normalized = item.name.trim().toLowerCase();

    if (!seen.has(normalized)) {
      seen.add(normalized);
      result.push({
        name: item.name,
        category: item.category,
      });

      if (result.length >= limit) break;
    }
  }

  return result;
}

/**
 * Hook version: returns recent foods from current inventory
 */
export function useRecentFoods(limit = 8): RecentFood[] {
  const items = useSelector(selectAllInventory);
  return recentFoods(items, limit);
}
